// ============================================================
// WhiteLabel — 프리미엄 / 스튜디오 섹션 (정적, 서버 컴포넌트)
// 톤: "있지만 밀지 않는다" (가이드 §2.6)
// 메인 홈에는 가격표 노출 금지 (가이드 §6.7)
// ============================================================

import { I } from "@/components/kamibot-v2/discord";

export function WhiteLabel() {
  return (
    <section id="white-label" className="wl">
      <div className="shell">
        <div className="wl-grid">
          <div className="wl-copy">
            <span className="section-eyebrow">
              <I.sparkle /> 프리미엄 · 스튜디오
            </span>
            <h2 className="section-title">
              내 서버만의 봇으로,<br />이름도 얼굴도 다시.
            </h2>
            <p className="section-sub">
              카미봇의 모든 기능을 그대로, 우리 서버 색깔에 맞게.
              이름·아바타·임베드 색상·환영 카드까지 — <b>코드 한 줄 안 쓰고</b> 바꿔요.
              지원 서버에 묻거나 디스코드 봇 개발 공부할 필요 없어요.
            </p>

            <ul className="wl-bullets">
              <li>
                <span className="wl-bullet-ic"><I.sparkle /></span>
                <div>
                  <b>봇 이름·아바타·자기소개 그대로</b>
                  <span>&ldquo;카미봇&rdquo; 자리에 우리 서버 마스코트, 우리 길드 이름. 임베드 footer에서 카미봇 워터마크 사라져요.</span>
                </div>
              </li>
              <li>
                <span className="wl-bullet-ic"><I.brush /></span>
                <div>
                  <b>색·말투·이모지까지 매칭</b>
                  <span>임베드 색은 우리 서버 액센트로. 환영 멘트 톤, 명령어 응답 스타일도 우리답게.</span>
                </div>
              </li>
              <li>
                <span className="wl-bullet-ic"><I.shield /></span>
                <div>
                  <b>봇 소유권은 서버 관리자</b>
                  <span>봇 토큰은 본인만 보유. 카미봇 측은 운영에 필요한 최소 데이터만 처리해요.</span>
                </div>
              </li>
              <li>
                <span className="wl-bullet-ic"><I.bolt /></span>
                <div>
                  <b>업데이트는 자동으로</b>
                  <span>새로운 기능이 카미봇에 추가되면, 그날 우리 봇에도 반영돼요. 내가 코드를 따라잡을 필요 없어요.</span>
                </div>
              </li>
            </ul>

            <div className="wl-actions">
              <a href="/premium" className="btn btn-primary">
                <I.sparkle /> 스튜디오 알아보기
              </a>
              {/* TODO: 출시 전까지 노출 금지 (가이드 §6.7) */}
              {/* <span className="wl-note">월 ₩19,900부터 · 14일 환불 보장</span> */}
            </div>
          </div>

          <div className="wl-preview">
            <div className="wl-preview-label">멤버 리스트 미리보기</div>
            <div className="wl-mlist">
              <div className="wl-mlist-head">온라인 — 3</div>

              <div className="wl-row before">
                <div className="wl-tag">기본</div>
                <div className="av wl-av">
                  <img src="/kamibot-character/kamibot-portrait-pink.png" alt="" />
                </div>
                <div className="wl-meta">
                  <div className="wl-name">
                    카미봇 <span className="wl-bot is-verified">앱</span>
                  </div>
                  <div className="wl-status">&ldquo;/도와줘&rdquo; 입력해서 시작해요</div>
                </div>
              </div>

              <div className="wl-arrow">
                <span /><b>스튜디오로 변신</b><span />
              </div>

              <div className="wl-row after">
                <div className="wl-tag wl-tag-after">우리 서버</div>
                <div className="av wl-av wl-av-after">
                  <span className="wl-emoji">🦊</span>
                </div>
                <div className="wl-meta">
                  <div className="wl-name wl-name-after">
                    여우비 <span className="wl-bot">앱</span>
                  </div>
                  <div className="wl-status wl-status-after">오늘은 어떤 글쓰기 도와줄까요?</div>
                </div>
              </div>

              <div className="wl-mlist-foot">
                <div className="wl-foot-row">
                  <span>이름</span>
                  <code>카미봇</code>
                  <span className="wl-arrow-mini">→</span>
                  <code className="wl-after-val">여우비</code>
                </div>
                <div className="wl-foot-row">
                  <span>임베드 색</span>
                  <span className="wl-swatch" style={{ background: "var(--kbv2-primary)" }} />
                  <span className="wl-arrow-mini">→</span>
                  <span className="wl-swatch" style={{ background: "oklch(0.68 0.14 200)" }} />
                </div>
                <div className="wl-foot-row">
                  <span>환영 멘트</span>
                  <code className="wl-quote">&ldquo;환영해요!&rdquo;</code>
                  <span className="wl-arrow-mini">→</span>
                  <code className="wl-quote wl-after-val">&ldquo;잘 왔어 ✦&rdquo;</code>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
